/**
 * 问题编辑组件的状态控制
 */
import {
    getTreesData,
    queryQuestionDetail,
    questionEidtSave,
    searchRecSimilars,
    searchReferenceSimilars,
    queryAnswerProps,
    querySynonymQuestions,
    queryFormList,
    searchSimilarsList,
    addSimilar,
    updateSimilar,
    deleteSimilar
} from "@/views/zhiji/js/services/service.js";

import { uniqueId, genIndexSearchHandler, genItemSearchHandler } from "@/views/zhiji/js/common/util.js";
import { quesSaveType } from "@/views/zhiji/js/common/constants.js";
import { businessLangs } from "@/components/langSelect/languages.js";
import { checkValidate } from "./checkQuesValidate.js";
import { isPubg, robotConfig, robotChannels } from "@/views/zhiji/js/lib/businessCheck.js";
import widgetManager from "./widgets/widgetManager.js";
import i18n from "@/i18n";

function getDefaultLang() {
    const business = robotConfig();
    return business ? business.defaultLang : "en";
}

export default {
    state: {
        sceneClassDatas: [],
        searchSceneClassDatas: [],
        questionInfo: {
            questionId: "",
            sceneClassId: "def",
            standQuestion: "",
            optionTip: "",
            lang: "",
            enQuestionId: 0,
            clusterId: "",
            clusterLang: "",
            clusterQuestionId: "",
            conventionQuestionId: null // 常规闭环传入的auto_id
        },
        answers: [],
        answerProp: {},
        similar: [],
        totalSimilar: 0,
        matchSimilarTotal: 0,
        recommendSimilar: [],
        deletedSimilars: [],
        delRecommendSimilars: [],
        recommendSimilarList: [],
        hasChange: false,
        isUpdating: "not", // not, sending, success
        currentAnswer: null,
        totalRecSimilars: 0,
        referenceSimilars: {
            data: [],
            status: "done"
        },
        recommendOptions: [],
        synonymQuestions: [],
        currentSynonym: "",
        formTypeDatas: [], // 所有的表单类型
        laborLinkDatas: []
    },
    mutations: {
        editQsClearModule(state) {
            state.sceneClassDatas.splice(0);
            state.searchSceneClassDatas.splice(0);
            state.questionInfo = {
                questionId: "",
                sceneClassId: "def",
                standQuestion: "",
                optionTip: "",
                clusterId: "",
                clusterLang: "",
                clusterQuestionId: "",
                conventionQuestionId: null,
                lang: getDefaultLang(),
                enQuestionId: 0
            };
            state.answers.splice(0);
            state.answerProp = {};
            state.similar.splice(0);
            state.recommendSimilar.splice(0);
            state.deletedSimilars.splice(0);
            state.delRecommendSimilars.splice(0);
            state.totalSimilar = 0;
            state.totalRecSimilars = 0;
            state.referenceSimilars = {
                data: [],
                status: "done"
            };
            state.hasChange = false;
            state.isUpdating = "not";
            state.currentAnswer = null;
            state.recommendOptions.splice(0);
        },
        editQsInitSynonymQuestion(state) {
            state.currentSynonym = getDefaultLang();

            state.synonymQuestions.splice(
                0,
                state.synonymQuestions.length,
                ...businessLangs().map(supportLang => {
                    return {
                        lang: supportLang.lang,
                        i18nKey: supportLang.i18nKey,
                        questionId: "",
                        status: "",
                        statusLabel: ""
                    };
                })
            );
        },
        editQsInit(state, quesDetail) {
            state.hasChange = false;
            state.questionInfo = Object.assign({}, state.questionInfo, quesDetail.info);
            state.answers.splice(0, state.answers.length, ...quesDetail.answers);

            if (quesDetail.isFirstTime && state.answers.length) {
                state.currentAnswer = state.answers[0];
            } else {
                state.answers.some(answer => {
                    if (answer.name != state.currentAnswer.name) {
                        return;
                    }

                    state.currentAnswer = answer;
                    return true;
                });
            }
        },
        intentAnsEditInit(state, answer) {
            state.currentAnswer = state.answers[0];
            if (answer) {
                state.answers = answer;
                state.currentAnswer = answer[0];
            }
        },
        updateEditScene(state, datas) {
            state.sceneClassDatas.splice(0, state.sceneClassDatas.length, ...datas);
            state.searchSceneClassDatas.splice(0, state.searchSceneClassDatas.length, ...datas);
        },
        updateEditQsForm(state, forms) {
            !forms.noChange && (state.hasChange = true);

            forms.sceneClassId && (state.questionInfo.sceneClassId = forms.sceneClassId);
            if (forms.standQuestion != undefined) {
                state.questionInfo.standQuestion = forms.standQuestion;
                state.questionInfo.optionTip = forms.optionTip;
            }
            forms.clusterLang && (state.questionInfo.clusterLang = forms.clusterLang);
            forms.clusterId && (state.questionInfo.clusterId = forms.clusterId);
            forms.clusterQuestionId && (state.questionInfo.clusterQuestionId = forms.clusterQuestionId);
            forms.conventionQuestionId && (state.questionInfo.conventionQuestionId = forms.conventionQuestionId);
            forms.recommendOptions && (state.recommendOptions = forms.recommendOptions);
        },
        editQsaddAnswer(state, data) {
            (!data || !data.noChange) && (state.hasChange = true);

            state.answers.push({
                name: i18n.t("zhiji.common.answer") + (state.answers.length + 1),
                contents: [],
                options: [],
                props: {
                    effectTime: {
                        startTime: "",
                        endTime: "",
                        curRadio: "all"
                    },
                    effectChannel: {
                        channel: robotChannels().map(item => item.value) // 临时方案可能要从后台取TODO
                    },
                    effectUser: ["21", "22", "23", "24", "25", "26", "27", "31", "32", "33", "34", "35", "178", "179"],
                    dmStatus: isPubg() ? ["default", "block"] : [] // 默认全选对话状态
                },
                updateState: "add",
                uId: uniqueId()
            });
        },
        editQsDeleteAnswer(state, data) {
            state.hasChange = true;

            deleteItemByUId(state.answers, data);

            if (state.currentAnswer && data.uId === state.currentAnswer.uId) {
                state.currentAnswer = null;
            }
        },
        editQsUpdateAnswer(state, data) {
            state.hasChange = true;

            const answers = state.answers;
            let editIdx = answers.indexOf(state.currentAnswer);

            if (editIdx === -1) {
                return; // TODO加个throw或者上报监控
            }

            const editAnswer = answers[editIdx];

            if (editAnswer.updateState !== "add") {
                editAnswer.updateState = "update";
            }

            answerUpdate(editAnswer, data);
        },
        updateAnswerProps(state, propsData) {
            state.answerProp = propsData;
        },
        editQsSelectAnswer(state, data) {
            state.currentAnswer = data;
        },
        editQsUpdatingState(state, data) {
            state.isUpdating = data.isUpdating;
            data.questionId && (state.questionInfo.questionId = data.questionId);
        },
        recommendSimilarInit(state, quesDetail) {
            let recSimilars = quesDetail.list;
            state.recommendSimilar.splice(0, state.recommendSimilar.length, ...recSimilars);
            state.deletedSimilars.splice(0);
            state.delRecommendSimilars.splice(0);
            state.recommendSimilarList = state.recommendSimilar;
            state.totalRecSimilars = quesDetail.count;
        },
        similarListInit(state, similarDetail) {
            state.totalSimilar = similarDetail.similarTotal;
            state.matchSimilarTotal = similarDetail.matchSimilarTotal;
            state.similar.splice(0, state.similar.length, ...similarDetail.similar);
        },
        searchRecommendSimilarName(state, data) {
            state.recommendSimilarList = state.recommendSimilar.filter(value => {
                return value.recSimilar.indexOf(data.keywords) != -1 && value.updateState != "delete";
            });
        },
        searchScenes(state, data) {
            let searchDatas = [];
            state.searchSceneClassDatas.forEach(item => {
                if (item.label.indexOf(data.field) != -1) {
                    searchDatas.push(item);
                }
            });
            data.field != "" ? (state.sceneClassDatas = searchDatas) : (state.sceneClassDatas = state.searchSceneClassDatas);
        },
        editQsUpdateSynonymQuestions(state, questionLangs) {
            const findByLang = genItemSearchHandler("lang");
            state.synonymQuestions.splice(
                0,
                state.synonymQuestions.length,
                ...businessLangs().map(supportLang => {
                    const questionStatus = findByLang(questionLangs, supportLang.lang) || {};
                    return {
                        lang: supportLang.lang,
                        i18nKey: supportLang.i18nKey,
                        questionId: questionStatus.questionId || "",
                        status: questionStatus.status || "",
                        statusLabel: questionStatus.statusLabel || ""
                    };
                })
            );
        },
        editQsUpdateCurrentSynonym(state, lang) {
            state.currentSynonym = lang;
            state.questionInfo.lang = lang;
        },
        updateFormList(state, fromData) {
            let cvtFormData = [];
            cvtFormData = fromData.dataset.map(item => {
                return {
                    label: `${item.firstTag} > ${item.secondTag} > ${item.name}`,
                    value: item.rowId
                };
            });
            state.formTypeDatas.splice(0, state.formTypeDatas.length, ...cvtFormData);
        },
        editQsUpdateEnQuesId(state) {
            if (state.currentSynonym != getDefaultLang()) {
                const findByLang = genItemSearchHandler("lang");
                const questionStatus = findByLang(state.synonymQuestions, getDefaultLang());
                state.questionInfo.enQuestionId = questionStatus.questionId;
            } else {
                state.questionInfo.enQuestionId = 0;
            }
        },
        updateLaborList(state, fromData) {
            let cvtFormData = [];
            cvtFormData = fromData.dataset.map(item => {
                return {
                    label: `${item.firstTag} > ${item.secondTag} > ${item.name}`,
                    value: {
                        formId: item.rowId,
                        tagIds: item.addData.tagId
                    }
                };
            });
            state.laborLinkDatas.splice(0, state.laborLinkDatas.length, ...cvtFormData);
        }
    },
    actions: {
        searchReferenceSimilars(context, param) {
            let similars = context.state.referenceSimilars;
            similars.status = "";
            similars.data = [];
            searchReferenceSimilars(param).then(result => {
                if (result.length === 0) {
                    similars.status = "done";
                }

                similars.data = result;
            });
        },
        searchRecommendSimilar(context, param) {
            searchRecSimilars(param).then(result => {
                // 语言切换太快可能出现前面请求比后面请求回来的慢，导致数据错误
                if (param.lang && param.lang != context.state.currentSynonym) {
                    return;
                }
                context.commit("recommendSimilarInit", result);
            });
        },
        querySimilarList(context, param) {
            searchSimilarsList(param).then(result => {
                context.commit("similarListInit", result);
            });
        },
        addSimilar(context, param) {
            addSimilar(param).then(result => {
                result && context.dispatch("querySimilarList", param);
            });
        },
        updateSimilar(context, param) {
            updateSimilar(param).then(result => {
                param.extQuestion = "";
                result && context.dispatch("querySimilarList", param);
            });
        },
        deleteSimilar(context, param) {
            deleteSimilar(param).then(result => {
                result && context.dispatch("querySimilarList", param);
            });
        },
        editQsInitScene(context, param) {
            getTreesData()
                .then(function(treeData) {
                    // 语言切换太快可能出现前面请求比后面请求回来的慢，导致数据错误
                    if (param.lang && param.lang != context.state.currentSynonym) {
                        return;
                    }

                    const sceneData = sceneTree2Selector(treeData);
                    context.commit("updateEditScene", sceneData);

                    // 区分新增答案入口
                    param.clusterId &&
                        context.commit("updateEditQsForm", {
                            clusterLang: param.clusterLang,
                            clusterId: param.clusterId,
                            clusterQuestionId: param.clusterQuestionId,
                            noChange: true
                        });

                    param.conventionQuestionId &&
                        context.commit("updateEditQsForm", {
                            conventionQuestionId: param.conventionQuestionId,
                            noChange: true
                        });

                    // 新增问题时设置当前选择的场景Id
                    const hasScene = param.sceneId ? sceneData.some(item => param.sceneId == item.value) : false;
                    if (hasScene) {
                        context.commit("updateEditQsForm", {
                            sceneClassId: param.sceneId,
                            noChange: true
                        });
                    }
                })
                .catch(err => showMessage(err, context));
        },
        editQsUpdateEditor(context, param) {
            context.dispatch("editQsInitScene", param);
            param.questionId
                ? queryQuestionDetail(param)
                      .then(function(quesDetail) {
                          // 语言切换太快可能出现前面请求比后面请求回来的慢，导致数据错误
                          if (param.lang && param.lang != context.state.currentSynonym) {
                              return;
                          }
                          quesDetail.isFirstTime = true;
                          context.commit("editQsInit", quesDetail);
                          context.commit("editQsUpdateCurrentSynonym", quesDetail.info.lang);
                      })
                      .catch(err => showMessage(err, context))
                : context.commit("editQsaddAnswer", { noChange: true });

            param.questionId
                ? context.dispatch("getFormTypeList", {
                      page: 1,
                      size: 10,
                      status: 1, // 只关联正常状态的表单
                      classId: ""
                  })
                : "";

            // 一期不上推荐相似问法，先注释掉接口入口
            // param.questionId && context.dispatch("searchRecommendSimilar", { questionId: param.questionId, lang: param.lang });
            param.questionId && context.dispatch("querySimilarList", { questionId: param.questionId });
            param.questionId && context.dispatch("editQsQuerySynonymQuestions", { questionId: param.questionId });
        },
        initQuesEditor(context, param) {
            context.state.questionInfo.lang = getDefaultLang();
            context.commit("editQsInitSynonymQuestion");
            context.dispatch("editQsUpdateEditor", param);
        },
        saveQuesEditor(context, param) {
            context.commit("editQsUpdatingState", { isUpdating: "sending" });
            context.commit("editQsUpdateEnQuesId");

            param = Object.assign({}, context.state, param);

            new Promise(function(resolve) {
                checkValidate(param);
                resolve();
            })
                .then(() => questionEidtSave(param))
                .then(function(questionId) {
                    // 更新语言栏状态
                    context.dispatch("editQsQuerySynonymQuestions", { questionId });

                    if (param.saveType == quesSaveType.SUBMIT || param.saveType == quesSaveType.OFFLINE) {
                        context.commit("editQsUpdatingState", { isUpdating: "success" });
                    }

                    return queryQuestionDetail({
                        questionId,
                        sceneId: context.state.questionInfo.sceneClassId
                    });
                })
                .then(function(quesDetail) {
                    quesDetail && context.commit("editQsInit", quesDetail);
                    quesDetail && context.commit("editQsUpdatingState", { isUpdating: "not" });
                })
                .catch(err => {
                    context.commit("editQsUpdatingState", { isUpdating: "not" });
                    showMessage(err, context);
                });
        },
        queryAnswerProps(context) {
            queryAnswerProps().then(function(propsData) {
                context.commit("updateAnswerProps", propsData);
            });
        },
        editQsUpdateLanguage(context, lang) {
            if (!businessLangs().some(supportLang => lang == supportLang.lang)) {
                return;
            }

            const findByLang = genItemSearchHandler("lang");
            const questionStatus = findByLang(context.state.synonymQuestions, lang);
            const info = context.state.questionInfo;
            const reqParam = {
                questionId: questionStatus ? questionStatus.questionId : "",
                sceneId: info.sceneClassId,
                lang: lang
            };
            context.commit("editQsClearModule");
            context.commit("editQsUpdateCurrentSynonym", lang);
            context.dispatch("queryAnswerProps");
            context.dispatch("editQsUpdateEditor", reqParam);
        },
        getFormTypeList(context, param) {
            queryFormList(param).then(formData => {
                context.commit("updateFormList", formData);
            });
        },
        getLobarListData(context, param) {
            queryFormList(param).then(formData => {
                context.commit("updateLaborList", formData);
            });
        },
        editQsQuerySynonymQuestions(context, param) {
            querySynonymQuestions(param).then(resp => context.commit("editQsUpdateSynonymQuestions", resp));
        }
    }
};

// 数据转换，tree转换成select组件需要的格式(不需返回一级)
function sceneTree2Selector(arr) {
    let newData = [];
    arr &&
        arr.forEach(item => {
            flatData(item.children, item.label, newData);
        });
    return newData;
}

function flatData(arr, label, newData) {
    arr &&
        arr.forEach(item => {
            let str = label ? label + ">" + item.label : item.label;
            newData.push({
                label: str,
                value: item.id
            });
            if (item.children.length != 0) {
                flatData(item.children, str, newData);
            }
        });
    return newData;
}

// 答案修改总入口
function answerUpdate(editAnswer, data) {
    const handlers = {
        name: answerNameUpdate,
        addContent: answerContentAdd,
        deleteContent: answerContentDelete,
        updateContent: answerContentUpdate,
        tranferContent: answerContentTransfer,
        addOption: answerOptionAdd,
        deleteOption: answerOptionDelete,
        updateOption: answerOptionUpdate,
        tranferOption: answerOptionTransfer,
        updateProp: answerPropUpdate,
        addContentItem: answerContentItemAdd,
        deleteContentItem: answerContentItemDelete,
        updateContentItem: answerContentItemUpdate,
        tranferContentItem: answerContentItemTransfer,
        updateCurrentAnswer: pasteCurrentAnswer
    };

    handlers[data.type].call(null, editAnswer, data);
}

// 答案名称改变
function answerNameUpdate(editAnswer, data) {
    editAnswer.name = data.newName;
}

// 答案内容增加widget
function answerContentAdd(editAnswer, data) {
    const widgetHandler = widgetManager.clientMap[data.wtType];

    widgetHandler && editAnswer.contents.push(widgetHandler.initContent());
}

// 答案内容删除widget
function answerContentDelete(editAnswer, data) {
    deleteItemByUId(editAnswer.contents, data.widget);
}

// 答案内容修改widget
function answerContentUpdate(editAnswer, data) {
    updateItemByUId(editAnswer.contents, data.widget);
}

// 答案内容移动widget
function answerContentTransfer(editAnswer, data) {
    transItemByUId(editAnswer.contents, data.widget);
}

// 列表答案内容增加列表项
function answerContentItemAdd(editAnswer, data) {
    let contentIdx = genIndexSearchHandler("uId")(editAnswer.contents, data.widget.uId);
    let content = editAnswer.contents[contentIdx];
    const widgetHandler = widgetManager.clientMap[content.wtType];

    if (content.updateState !== "add") {
        content.updateState = "update";
    }

    content.items.push(widgetHandler.initItem(data.widget.item));
}

// 列表答案内容删除列表项
function answerContentItemDelete(editAnswer, data) {
    answerContentItemOperate(deleteItemByUId)(editAnswer, data);
}

// 列表答案内容修改列表项
function answerContentItemUpdate(editAnswer, data) {
    answerContentItemOperate(updateItemByUId)(editAnswer, data);
}

//  列表答案内容移动列表项
function answerContentItemTransfer(editAnswer, data) {
    answerContentItemOperate(transItemByUId)(editAnswer, data);
}

// 粘贴到当前答案
function pasteCurrentAnswer(editAnswer, data) {
    editAnswer.contents = data.contents;
    editAnswer.options = data.options;
}

// 高阶函数，处理列表答案内容修改逻辑
function answerContentItemOperate(operateHandler) {
    return function(editAnswer, data) {
        let contentIdx = genIndexSearchHandler("uId")(editAnswer.contents, data.widget.uId);
        let content = editAnswer.contents[contentIdx];

        if (content.updateState !== "add") {
            content.updateState = "update";
        }

        operateHandler(content.items, data.widget.item);
    };
}

// 答案快捷栏添加
function answerOptionAdd(editAnswer, data) {
    if (data.recommend) {
        editAnswer.options = data.options;
    } else {
        editAnswer.options.push({
            uId: uniqueId(),
            name: "",
            questionId: "",
            question: "",
            updateState: "add",
            optionType: "question",
            itemType: (data.option && data.option.itemType) || ""
        });
    }
}

// 答案快捷栏删除
function answerOptionDelete(editAnswer, data) {
    deleteItemByUId(editAnswer.options, data.option);
}

// 答案快捷栏修改
function answerOptionUpdate(editAnswer, data) {
    updateItemByUId(editAnswer.options, data.option);
}

// 答案快捷栏移动
function answerOptionTransfer(editAnswer, data) {
    transItemByUId(editAnswer.options, data.option);
}

// 答案属性更新
function answerPropUpdate(editAnswer, data) {
    if (data.effectTime) {
        editAnswer.props = Object.assign({}, editAnswer.props, {
            effectTime: data.effectTime
        });
    }

    if (data.effectChannel) {
        editAnswer.props = Object.assign({}, editAnswer.props, {
            effectChannel: data.effectChannel
        });
    }

    if (data.effectUser) {
        editAnswer.props = Object.assign({}, editAnswer.props, {
            effectUser: data.effectUser
        });
    }

    if (data.dmStatus) {
        editAnswer.props = Object.assign({}, editAnswer.props, {
            dmStatus: data.dmStatus
        });
    }

    // if(data.mobileType) {
    //     editAnswer.props = Object.assign({}, editAnswer.props, {
    //         mobileType: data.mobileType
    //     });
    // }
}

// 删除或更改元素状态抽象函数 uId, updateState
function deleteItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item.updateState == "add") {
        items.splice(itemIdx, 1);
    } else {
        item.updateState = "delete";
    }
}

// 更新并且更改元素状态抽象函数 uId, updateState
function updateItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item.updateState !== "add") {
        item.updateState = "update";
    }

    let updatedItem = Object.assign({}, item, newItem);
    items.splice(itemIdx, 1, updatedItem);
}

// 更新并且更改元素状态抽象函数 uId, updateState
function transItemByUId(items, param) {
    const itemIdx = genIndexSearchHandler("uId")(items, param.uId);
    const item = items[itemIdx];

    if (param.newIdx < 0 || param.newIdx === itemIdx) {
        return;
    }

    items.splice(itemIdx, 1);
    items.splice(param.newIdx, 0, item);
}

function showMessage(err, context) {
    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
        context.commit("showModal", {
            type: "messageModal",
            data: {
                type: "error",
                message: err.message
            }
        });

        return true;
    } else {
        console.error(err);
    }
}
